// ** Type Import
import { OwnerStateThemeType } from "..";

const Tabs = () => {
  return {
    MuiTabs: {
      styleOverrides: {
        vertical: ({ theme }: OwnerStateThemeType) => ({
          minWidth: 130,
          marginRight: theme.spacing(4),
          borderRight: `1px solid ${theme.palette.divider}`,
          "& .MuiTab-root": {
            minWidth: 130,
          },
        }),
        root: ({ theme, ownerState }: OwnerStateThemeType) => ({
          borderRadius: 4,
          "&.secondary": {
            minHeight: 0,
            backgroundColor: theme.palette.secondary.light,
            "& .MuiTabs-flexContainer": {
              borderRadius: 4,
            },
            "& button": {
              backgroundColor: theme.palette.secondary.light,
              padding: `${theme.spacing(2)} ${theme.spacing(4)}`,
              margin: theme.spacing(2),
              minHeight: "20px",
              borderRadius: 3,
              "&.Mui-selected": {
                fontWeight: "bold",
                backgroundColor: theme.palette.common.white,
                "&:hover": {
                  backgroundColor: theme.palette.common.white,
                },
              },
              "&:hover": {
                backgroundColor: "#f1f1f3",
              },
            },
            ".MuiTabs-indicator": {
              display: "none",
            },
          },
        }),
        container: ({ theme }: OwnerStateThemeType) => ({
          "&.secondary": {
            backgroundColor: theme.palette.secondary.light,
          },
        }),
      },
    },
    MuiTab: {
      styleOverrides: {
        root: ({ theme }: OwnerStateThemeType) => ({
          textTransform: "none",
          "&.Mui-selected": {
            fontWeight: "bold",
          },
        }),
      },
    },
  };
};

export default Tabs;
